import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {Condition} from '../model/Conditions/Condition';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {MultipleCondition} from '../model/Conditions/MultipleCondition';
import {QuestionCondition} from '../model/Conditions/QuestionCondition';

@JsonConverter
export class ConditionConverter implements JsonCustomConvert<Condition> {
    deserialize(json: any): Condition {

        let res:Condition;

            if(json.conditionClass === 'multiple') {
                res = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json,MultipleCondition);

            } else if(json.conditionClass === 'simple') {
                res = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json,QuestionCondition);
            }

        return res;
    }

    serialize(data: Condition): any {
        return JSON.stringify(data);
    }

}
